import { PreviewTitle } from "./PreviewTitle";
import { useAiSaasInputContainer } from "../container";
import isBlank from "@sedan-utils/is-blank";
import css from "./index.module.scss";

export function InputTitle(props: AISaas.AISaasInputItemTitleProps) {
  const { x } = props;
  const { id: itemId } = x.data;

  const {
    aiSaasProps,
    inputTitleId,
    showInputTitleId,
    onInputTitleBlur,
    onInputTitleEnter,
    onClickInputTitle,
    onSaasInputTitleChange,
    onClickInputTitleClose,
  } = useAiSaasInputContainer();

  const inputTitle = x.data.inputTitle || x?.data?.generatedLabel || "User Input";

  return (
    <div className={css["input-title-box"]}>
      <PreviewTitle
        id={itemId}
        title={inputTitle}
        isShare={true}
        inputTitleId={inputTitleId.value}
        onInputTitleBlur={onInputTitleBlur}
        onInputTitleEnter={onInputTitleEnter}
        onSaasInputTitleChange={onSaasInputTitleChange}
        onClickInputTitleClose={onClickInputTitleClose}
        onClickEdit={onClickInputTitle}
        showInputTitleId={showInputTitleId.value}
        saasUIInputData={x}
      />
    </div>
  );
}
